var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import Transition from "../../../organisms/obligationsQuestionnaire/obligationsTransition";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateNeedsQuestionnaire } from "../../../../redux/actions/dashboard";
function ObligationsTransition() {
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var error = useState("")[0];
    var logged_in_user_type = useSelector(function (state) { return state.rootReducer.dashboardReducer.logged_in_user_type; });
    // function to continue to obligations
    var handleContinue = function () {
        if (logged_in_user_type === "adviser") {
            navigate("/questionnaire/adviserClientObligations");
        }
        else {
            navigate("/questionnaire/clientObligations");
        }
    };
    var handleSkip = function () {
        if (logged_in_user_type !== "adviser") {
            dispatch(updateNeedsQuestionnaire(false));
        }
        navigate("/dashboard");
    };
    var contentString = "\n        If you are seeing an adviser, you are expected to complete this feedback after your meeting. \n        This involves reflecting on your own expectations of activities and engagement, as well as those of your adviser, to see how well they align.\n        There are no right or wrong answers, and this is not an assessment of your adviser. \n        The purpose is simply to help your adviser understand how they can best support you in your employability journey.\n        ";
    if (logged_in_user_type === "adviser") {
        contentString = "\n        If you are meeting with a customer, you are expected to complete this feedback after your session. \n        This involves reflecting on your own expectations of activities and engagement, as well as those of the customer, to see how well they align.\n        There are no right or wrong answers, and this is not an assessment of your customer or you. \n        The purpose is to help you understand how you can best support them in their employability journey.\n        ";
    }
    var title = logged_in_user_type === "adviser" ? "Adviser Expectations" : "Customer Expectations";
    return (_jsxs("div", __assign({ className: "" }, { children: [error && _jsx("div", __assign({ className: "error-message" }, { children: error })), _jsx(Transition, { title: title, content: contentString, handleContinue: handleContinue, handleSkip: handleSkip })] })));
}
export default ObligationsTransition;
